// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';
import SubAccountMiddleware from '@middleware/SubAccountMiddleware';

// Layouts
import LayoutApp from '@layouts/LayoutApp';

export default {
    path: '/',
    component: LayoutApp,
    children: [
        {
            path: 'account',
            name: 'account',
            component: () => import('@pages/account'),
            redirect: { name: 'account.user' },
            meta: {
                middleware: AuthMiddleware,
                title: 'titles.account',
            },
            children: [
                {
                    path: 'user',
                    name: 'account.user',
                    component: () => import('@pages/account/PageAccountUser'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.account', 'labels.user_info'],
                    },
                },
                {
                    path: 'spaces',
                    name: 'account.spaces',
                    component: () => import('@pages/account/PageAccountSpaces'),
                    meta: {
                        middleware: [AuthMiddleware, SubAccountMiddleware],
                        title: ['titles.account', 'labels.spaces'],
                    },
                },
                {
                    path: 'spaces/:id',
                    name: 'account.spaces.space',
                    component: () => import('@pages/space'),
                    meta: {
                        middleware: [AuthMiddleware, SubAccountMiddleware],
                        title: ['titles.account', 'labels.space'],
                    },
                },
                {
                    path: 'ltd',
                    name: 'account.ltd',
                    component: () => import('@pages/account/PageAccountLtd'),
                    meta: {
                        middleware: [AuthMiddleware, SubAccountMiddleware],
                        title: ['titles.account', 'labels.lifetime_deal'],
                    },
                },
            ],
        },
        {
            path: 'account',
            component: () => import('@pages/account'),
            props: { narrow: false },
            children: [
                {
                    path: 'billing',
                    name: 'account.billing',
                    component: () => import('@pages/billing'),
                    meta: {
                        middleware: [AuthMiddleware, SubAccountMiddleware],
                        title: ['titles.account', 'labels.billing'],
                    },
                },
                {
                    path: 'referrals',
                    redirect: { name: 'referrals' },
                },
            ],
        },
    ],
};